import {
  SHOW_SELECTED_WALLET,
  RESET_SELECTED_WALLET
} from "../types";

const initialState = {
  selectedWalletDetail: {}
};

export default (state = initialState, action) => {
  switch (action.type) {

    case SHOW_SELECTED_WALLET:
      return {
        ...state,
        selectedWalletDetail: action.payload
      }

    case RESET_SELECTED_WALLET:
      return {
        ...state,
        selectedWalletDetail: {}
      }

    default:
      return state;
  }
};
